import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { ICodeExists, ILateandLienScheduleDetails, ISaveDeleteResponse, IStore, ITaxGroup, ITaxGroupDetails } from '../Shared/interface';
import {AppService} from './app.service';

@Injectable({
  providedIn: 'root'
})
export class TaxGroupService {

  private baseURL = this.appService.config.apiBaseUrl;
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  
    constructor(private http: HttpClient, private appinsights: AppInsightsService, private appService: AppService) { }
  
    availableStoreList(taxoptionId): Observable<IStore[]> {
      return this.http.get<IStore[]>(
        `${this.baseURL}/TaxGroup/AvailableStoreList?TaxOptionId=${taxoptionId}`)
        .pipe(
          map(assignedstore => {
            return assignedstore as IStore[];
          }),
          catchError(this.handleError)
        );
    }
    
    isTaxGroupNameExists(code: string): Observable<ICodeExists> {
      return this.http.get<ICodeExists>(
        `${this.baseURL}/TaxGroup/IsTaxGroupNameExists?taxGroupName=${code}`,
        { observe: 'response' })
        .pipe(
          map(result => {
            let isExist: boolean;
            const codeExist = result.body as ICodeExists;
            if ((typeof codeExist === 'undefined') || (codeExist === null)) {
              isExist = false;
              return codeExist;
            } else {
              return codeExist;
            }
          }
          ),
          catchError(this.handleError)
        );
    }
  
    saveTaxGroup(details): Observable<ISaveDeleteResponse> {
      var url = `${this.baseURL}/TaxGroup/SaveTaxGroup`;
      return this.http.post<ISaveDeleteResponse>(url, details, this.options)
        .pipe(
          map(res => {
            console.log(res);
            return res;
          }),
          catchError(this.handleError)
        );
    }
  
    getTaxGroupList(): Observable<ITaxGroup[]> {
      return this.http.get<ITaxGroup[]>(
         `${this.baseURL}/TaxGroup/GetTaxGroupList`,
            { observe: 'response' })
        .pipe(
          map(res => {
            const listdata = res.body as ITaxGroup[];
            return listdata;
          }),
          catchError(this.handleError)
        );
    }
    
    getTaxGroupdetails(Id: number): Observable<ITaxGroupDetails> {
      return this.http.get<ITaxGroupDetails>(
        `${this.baseURL}/TaxGroup/GetTaxGroupdetails?taxGroupId=${Id}`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const Details = res.body as ITaxGroupDetails;
            return Details;
          }),
          catchError(this.handleError)
        );
    }
  
    deletetaxGroup(Id: number): Observable<ISaveDeleteResponse>  {
  
      return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/TaxGroup/DeletetaxGroup?taxGroupId=${Id}`, this.options)
        .pipe(
          map(res => {
            return res;
          }),
          catchError(this.handleError)
        );
    }

    getAssginedStoresforaTax(Id: number): Observable<any[]> {
      return this.http.get<any[]>(
        `${this.baseURL}/TaxGroup/GetAssginedStoresforaTax?TaxId=${Id}`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const Details = res.body as any[];
            return Details;
          }),
          catchError(this.handleError)
        );
    }

    
    getTaxAppliedforFacility(Id: number): Observable<any> {
      return this.http.get<any>(
        `${this.baseURL}/TaxGroup/GetTaxAppliedforFacility?TaxOptionId=${Id}`,
        { observe: 'response' })
        .pipe(
          map(res => {
            const Details = res.body as any;
            return Details;
          }),
          catchError(this.handleError)
        );
    }




    GetAssginedStoresforaTax
  
  
    private handleError(error: HttpErrorResponse) {
      console.error('server error:', error);
      if (error.error instanceof Error) {
        const errMessage = error.error.message;
        this.appinsights.logEvent(errMessage);
        return throwError(errMessage);
      }
      return throwError(error || 'Node.js server error');
    }
}
